import axiosCall from './interceptor';
import URL from '../helper'


export const createNewOrganization = async payload => {
  const url = `${URL.BASE_URL}client/organization`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};
 
export const getAllOrganizations = async () => {
  const url = `${URL.BASE_URL}fetchOrganization?includeDeleted=true`;
  let response = await axiosCall('get', url);
  return response.data;
};
 
export const signInOrganization = async orgId => {
  const url = `${URL.AUTH_SERVICE_URL}master/signin?organizationId=${orgId}`;
  let response = await axiosCall('post', url);
  return response.data;
};
 
export const updateOrgStatus = async (orgId, status) => {
  const url = `${URL.BASE_URL}organizations/${orgId}/status?status=${status}`;
  let response = await axiosCall('patch', url);
  return response.data;
};

export const updateOrgFeatures = async payload => {
  const url = `${URL.BASE_URL}config/organization`;
  let response = await axiosCall('post', url, payload);
  return response.data;
}
 
export const signOutOrganization = async payload => {
  const url = `${URL.AUTH_SERVICE_URL}master/signout`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};